export function roundAndToFixed(value, demical){
    const n = Math.pow(10, demical)
    return (Math.round(value * n)/n).toFixed(demical)
}
export function frequency(score, numOfDist) {
    let dist = Array(numOfDist).fill(0)
    score.forEach((e) => dist[e - 1] = dist[e - 1] + 1)
    return dist
}
export function round(value, demical) {
    const n = Math.pow(10, demical);
    return Math.round(value * n) / n;
  }